import React from 'react';
import { domainLabel } from '../emailHelpers';

export const FILTERS = [
  ['all', 'All'],
  ['spam', 'Likely spam'],
  ['clean', 'Not spam'],
  // server-side type filters (see FILTER_TYPES); their counts are the unhandled ones
  ['feedback', 'Reader feedback'],
  ['contact', 'Contact form'],
];

/**
 * Domain select + search box + spam filter chips.
 *
 * <InboxToolbar domainId domains search filter counts onDomainChange onSearchChange onFilterChange />
 */
export default function InboxToolbar({
  domainId, domains, search, filter, counts,
  onDomainChange, onSearchChange, onFilterChange,
}) {
  return (
    <>
      <div className="toolbar">
        <select
          className="select"
          value={domainId}
          onChange={(e) => onDomainChange(e.target.value)}
          aria-label="Filter by domain"
        >
          <option value="">All domains</option>
          {/* A domain arriving from the URL may not be in the list the API
              returned (id-form drift). Show it rather than silently falling
              back to "All domains" while the list stays filtered. */}
          {domainId && !domains.includes(domainId) && (
            <option value={domainId}>{domainLabel(domainId)} (filtered)</option>
          )}
          {domains.map((d) => (
            <option key={d} value={d}>{domainLabel(d)}</option>
          ))}
        </select>
        <input
          type="search"
          className="input grow"
          placeholder="Search subject or sender…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Search emails"
        />
        {search && (
          <button type="button" className="btn btn-secondary" onClick={() => onSearchChange('')}>Clear</button>
        )}
      </div>

      <div className="chip-group" role="tablist" aria-label="Spam filter">
        {FILTERS.map(([key, label]) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={filter === key}
            className={`chip${filter === key ? ' active' : ''}`}
            onClick={() => onFilterChange(key)}
          >
            {label}
            {counts && counts[key] != null && <span className="count"> {counts[key]}</span>}
          </button>
        ))}
      </div>
    </>
  );
}
